module.exports = __webpack_public_path__ + "img/nerso-cover.8eeeb58f.jpg";